webpackJsonp([72776394686286],{

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _rlaComponents = __webpack_require__(7);
	
	__webpack_require__(221);
	
	var _theme = __webpack_require__(6);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _generatePostLayout = __webpack_require__(241);
	
	var _generatePostLayout2 = _interopRequireDefault(_generatePostLayout);
	
	var _LoadMore = __webpack_require__(461);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	var _helpers = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var rowsAdvance = 3;
	
	var NewsPage = function (_React$Component) {
	    _inherits(NewsPage, _React$Component);
	
	    function NewsPage(props) {
	        _classCallCheck(this, NewsPage);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    NewsPage.prototype.componentDidMount = function componentDidMount() {
	        var news = this.props.news;
	
	
	        var chunks = (0, _helpers.randomChunkArray)(news, 2, 4);
	
	        var layout = (0, _generatePostLayout2.default)(chunks);
	
	        this.setState({
	            rows: rowsAdvance,
	            chunkedNews: chunks,
	            layout: layout
	        });
	
	        //console.log(chunks);
	    };
	
	    NewsPage.prototype.handleClick = function handleClick() {
	        this.setState({
	            rows: this.state.rows + rowsAdvance
	        });
	    };
	
	    NewsPage.prototype.render = function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            chunkedNews = _state.chunkedNews,
	            rows = _state.rows,
	            layout = _state.layout;
	
	
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                _rlaComponents.Row,
	                { expanded: true, collapse: true },
	                chunkedNews && chunkedNews.slice(0, rows).map(function (items, i) {
	                    return layout[i](items);
	                })
	            ),
	            chunkedNews && chunkedNews.length > rows && _react2.default.createElement(
	                _LoadMore2.default,
	                { onClick: function onClick() {
	                        return _this2.handleClick();
	                    } },
	                "Load More"
	            )
	        );
	    };
	
	    return NewsPage;
	}(_react2.default.Component);
	
	exports.default = NewsPage;
	module.exports = exports["default"];

/***/ }),

/***/ 1153:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _theme = __webpack_require__(6);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _NewsList = __webpack_require__(239);
	
	var _NewsList2 = _interopRequireDefault(_NewsList);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var rowsAdvance = 3;
	
	var NewsPage = function (_React$Component) {
	    _inherits(NewsPage, _React$Component);
	
	    function NewsPage() {
	        _classCallCheck(this, NewsPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    NewsPage.prototype.render = function render() {
	        var _props = this.props,
	            news = _props.data.allMarkdownRemark.edges,
	            transition = _props.transition;
	
	
	        return _react2.default.createElement(
	            "div",
	            { style: transition && transition.style },
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                { title: "News | RLA Group | Full Service Advertising Agency" },
	                _react2.default.createElement("meta", {
	                    name: "title",
	                    content: "News | RLA Group | Full Service Advertising Agency"
	                }),
	                _react2.default.createElement("meta", {
	                    name: "description",
	                    content: "Check out the latest news, insights, trends in the advertising industry and culture pieces from RLA Group here."
	                })
	            ),
	            _react2.default.createElement(
	                _rlaComponents.Row,
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    null,
	                    _react2.default.createElement(
	                        _HeaderBlock2.default,
	                        {
	                            fontSize: _theme2.default.pageHeaderSection.fontSize,
	                            padding: _theme2.default.pageHeaderSection.padding },
	                        "News & ",
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "Insights"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_NewsList2.default, { news: news })
	        );
	    };
	
	    return NewsPage;
	}(_react2.default.Component);
	
	exports.default = NewsPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _reactAnimateOnScroll = __webpack_require__(230);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _helpers = __webpack_require__(12);
	
	var _NewsSummary = __webpack_require__(158);
	
	var _NewsSummary2 = _interopRequireDefault(_NewsSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastarrayIndex = null;
	
	exports.default = function (chunks) {
	    var result = new Array();
	
	    var layouts = {
	        0: [function () {
	            return null;
	        }],
	        1: [function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                )
	            );
	        }],
	        2: [function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 8, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 500
	                        })
	                    )
	                )
	            );
	        }, function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 8, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 500
	                        })
	                    )
	                )
	            );
	        }],
	        3: [function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 6, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 3, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 3, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 50,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[2].node || data[2],
	                            height: 500
	                        })
	                    )
	                )
	            );
	        }, function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 6, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 6, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 250
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[2].node || data[2],
	                            height: 250
	                        })
	                    )
	                )
	            );
	        }],
	        4: [function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 500,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 250
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[2].node || data[2],
	                            height: 250
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 750,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[3].node || data[3],
	                            height: 500
	                        })
	                    )
	                )
	            );
	        }, function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 500
	                        }),
	                        " "
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 500,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[2].node || data[2],
	                            height: 250
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 750,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[3].node || data[3],
	                            height: 250
	                        }),
	                        " "
	                    )
	                )
	            );
	        }]
	    };
	
	    chunks.map(function (chunk, i) {
	        var layoutArray = layouts[chunk.length];
	        var getArrayIndex = function getArrayIndex() {
	            return (0, _helpers.random)(0, layoutArray.length - 1);
	        };
	        var arrayIndex = 0;
	
	        // make sure that there are no duplicate rows if possible
	        if (layoutArray.length > 1) {
	            arrayIndex = getArrayIndex();
	            while (arrayIndex == lastarrayIndex) {
	                arrayIndex = getArrayIndex();
	            }
	            lastarrayIndex = arrayIndex;
	        }
	
	        result.push(layoutArray[arrayIndex]);
	    });
	
	    return result;
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-js-a1d5d562f32dda696b84.js